import { LruObjectCache, createCachedSelector } from 're-reselect';
import { createSelector } from 'reselect';

import { securitiesSelectors, securitiesUtils } from '../securities';

import { INVESTMENT_SYMBOLS_KEY, mkInvestmentSymbol } from './investmentSymbolsTypes';

export const getResourceStore = (state) => state[INVESTMENT_SYMBOLS_KEY];
export const getLoadPending = (state) => getResourceStore(state).loadPending;
export const getIsLoading = (state) => getResourceStore(state).isLoading;
export const getResourcesById = (state) => getResourceStore(state).resourcesById;

export const getInvestmentSymbolsUnion = createSelector(
  getResourcesById,
  securitiesSelectors.getResourcesById,
  (symbols, securities) =>
    symbols.withMutations((map) => {
      securities.forEach((security) => {
        const symbolMatch = map.get(security.symbol);
        if (symbolMatch) {
          map.set(security.symbol, symbolMatch.set('security', security));
        } else {
          const id = securitiesUtils.securityKey(security);
          map.set(
            id,
            mkInvestmentSymbol({
              id,
              symbol: security.symbol,
              name: security.name,
              security,
            }),
          );
        }
      });
    }, securities),
);

export const getInvestmentSymbolsFiltered = createCachedSelector(
  getInvestmentSymbolsUnion,
  (state, filter) => filter?.toUpperCase(),
  (investmentSymbols, filter) =>
    investmentSymbols
      .filter(
        (investmentSymbol) =>
          filter &&
          (investmentSymbol.symbol?.toUpperCase().includes(filter) ||
            investmentSymbol.name.toUpperCase().includes(filter)),
      )
      .toList()
      .sort(
        (investmentSymbol1, investmentSymbol2) =>
          (investmentSymbol1.symbol?.toUpperCase().startsWith(filter) ? 0 : 1) -
            (investmentSymbol2.symbol?.toUpperCase().startsWith(filter) ? 0 : 1) ||
          (investmentSymbol1.symbol?.toUpperCase().includes(filter) ? 0 : 1) -
            (investmentSymbol2.symbol?.toUpperCase().includes(filter) ? 0 : 1) ||
          investmentSymbol1.symbol.localeCompare(investmentSymbol2.symbol),
      ),
)({
  keySelector: (_state, filter) => filter ?? '',
  cacheObject: new LruObjectCache({ cacheSize: 10 }),
});
